<div class="container-fluid" *ngIf="isUserLoggedIn()">
  <div class="container-flex" id="landing-items-flex-div">
    <div *ngIf="showCriminalData()" id="ciprs-landing-route-criminal" class="landing-item"> 
      <i class="fa fa-shield fa-3x" aria-hidden="true"></i>
      <div class="landing-item-title">Search for <span class="landing-item-highlight">Criminal</span> Court Records</div>
      <p>View, print or email public records of infraction and criminal court cases.</p>
      <div class="row">
        <button class="btn btn-default landing-item-button" (click)="goToCriminalCiprs()" tabindex="31">Search</button>
        <a class="landing-item-link" (click)="openTellMeMore(criminalTellMeMore)" href="javascript:void(0)" tabindex="32">Tell me more about<br>what I can find here.</a>
      </div>
    </div>
    <div *ngIf="showCivilData()" id="ciprs-landing-route-civil-all" class="landing-item"> 
      <i class="fa icon-court-search icon-align fa-3x" aria-hidden="true"></i>
      <div class="landing-item-title">Search for <span class="landing-item-highlight">Civil</span> Court Records</div>
      <p>View, print or email public records of civil actions, estate cases, registrations, special proceedings and more.</p>
      <div class="row">
        <button class="btn btn-default landing-item-button" [routerLink]="['/civil', 'All']"  tabindex="33">Search</button>
        <a class="landing-item-link" (click)="openTellMeMore(civilTellMeMore)" href="javascript:void(0)" tabindex="34">Tell me more about<br>what I can find here.</a>
      </div>
    </div>
    <div *ngIf="showJuvenileData()" id="ciprs-landing-route-juvenile" class="landing-item">
      <i class="fa fa-child fa-3x" aria-hidden="true"></i>
      <div class="landing-item-title">Search for <span class="landing-item-highlight">Juvenile</span> Court Records</div>
      <p>View court records for juvenile delinquency cases.</p>
      <div class="row">
        <button class="btn btn-default landing-item-button" [routerLink]="['/juvenile']" tabindex="35">Search</button>
        <a class="landing-item-link" (click)="openTellMeMore(juvenileTellMeMore)" href="javascript:void(0)" tabindex="36">Tell me more about<br>what I can find here.</a>
      </div>
    </div>
    
  </div>
</div>
<ng-template #criminalTellMeMore>
  <div class="modal-header">
      <h1 class="logo float-left">
          North Carolina Judicial Branch
      </h1>
      <button class="btn btn-primary btn-ciprs pull-right" (click)="closeTellMeMore()">Close</button>
  </div>
  <div class="modal-body container-fluid">
    <h1>What Criminal Court Records Can I Find Here?</h1>
    <p>This system provides access to cases covering infraction, misdemeanor, and felony offenses. It contains information on these cases pertaining to actions, filings, and proceedings in the district and superior courts of the North Carolina Judicial Branch. This system does not maintain case information for federal cases or North Carolina Appellate or Supreme Court cases.</p>
    <p>Starting in 1982, North Carolina clerks of superior court gained access and started recording infractions and criminal cases in this centralized database over an eight-year long roll-out to all but one of North Carolina’s 100 counties. The exception was Mecklenburg County which started recording infractions in 1993 and criminal records in 1996. Since that time, clerks have added older cases as necessary. You may come across some cases as old as 1966. On the other hand, based on record retention schedules, some electronic records may no longer be available.</p>
    <p>Particularly if it is an older case, if you cannot find a case in this system, you may need to ask the clerk of superior court in the county where the case was filed for assistance.</p>
    <p>The following information may be found in this system:</p>
    <ul>
      <li>Bills of Information</li>
      <li>Citations</li>
      <li>Criminal Summonses (including Worthless Check Criminal Summons)</li>
      <li>Warrants for Arrest (including Fugitive Warrants and Worthless Check Warrants)</li>
      <li>Magistrate Orders (including Fugitive Orders)</li>
      <li>True Bills of Indictment</li>
      <li>Statements of Charges</li>
      <li>Governor’s Warrants</li>
      <li>Out-of-county Probation Violation</li>
      <li>Show Cause</li>
      <li>Criminal Contempt</li>
    </ul>
    <p>The system also gives limited information regarding Orders for Arrest and Release Orders.</p>
    <p>Not available in this system are:</p>
    <ul>
      <li>Cases from any jurisdiction other than North Carolina District and Superior Court</li>
      <li>Search Warrants</li>
      <li>Civil Child Support Orders for Arrest</li>
      <li>Civil Domestic Violence Protective Orders</li>
    </ul>
    <p>This system explicitly does not provide access to non-public information including</p>
    <ul>
      <li>Expunged cases</li>
      <li>Cases sealed by a judicial order</li>
      <li>Unserved warrants for arrest (unless they have been returned to the clerk by law enforcement)</li>
      <li>Involuntary commitment orders</li>
      <li>Personal Identifying Information (PII)</li>
    </ul>
    <button class="btn btn-primary pull-right" (click)="closeTellMeMore()">Close</button>
  </div>
</ng-template>
<ng-template #civilTellMeMore>
    <div class="modal-header">
      <h1 class="logo float-left">
          North Carolina Judicial Branch
      </h1>
      <button class="btn btn-primary btn-ciprs pull-right" (click)="closeTellMeMore()">Close</button>
    </div>
    <div class="modal-body container-fluid">
    <h1>What Civil Court Records Can I Find Here?</h1>
    <p>This system provides access to non-criminal court cases. It contains information pertaining to actions, filings, and proceedings in the magistrate’s courts, district courts, and superior courts, or before a Clerk of Superior Court of the North Carolina Judicial Branch. This system does not maintain case information for federal cases or North Carolina Appellate or Supreme Court cases.</p>
    <p>Starting in 1988, North Carolina clerks of superior court gained access and started recording civil case and judgment information electronically. From 1996 to 1997, capability to record other case types was added. From 2004 to 2005, clerks gained the ability to record full judgment abstracts electronically. Since that time, clerks have added older cases as necessary. You may come across some cases as old as 1966. See the table of system go-live dates by county below.</p>
    <p>The following information may be found in this system:</p>
    <ul>
      <li>Small Claims Cases - Monetary claims up to an amount between $5,000 and $10,000 as determined by local judicial order of the chief district court judge</li>
      <li>District Court Civil Actions - For example,
        <ul>
          <li>Monetary claims $25,000 or less, or any amount when it pertains to domestic matters</li>
          <li>Domestic Violence Protective Orders</li>
        </ul>
      </li>
      <li>Superior Court Civil Actions - Monetary claims in excess of $25,000</li>
      <li>Civil Judgments on Criminal Cases - Judgment attorney fees, victim’s restitution, fines, and costs pertaining to both District Court and Superior Court criminal case</li>
      <li>Civil Judgments on Juvenile Cases - Judgments of attorney fees, victim’s restitution, fines, and costs pertaining to
        <ul>
          <li>Abuse, neglect, dependency</li>
          <li>Termination of Parental Rights</li>
          <li>Delinquency</li>
          <li>Emancipation</li>
          <li>Responsible Individuals</li>
          <li>Judicial waivers of parental consent</li>
        </ul>
      </li>
      <li>Estates, Trusts, and Guardianships - For example, 
        <ul>
          <li>Recording and probate of wills</li>
          <li>Filings of annual and final accounts</li>
          <li>Entering inheritance tax certificates</li>
          <li>Assignments of title</li>
          <li>Guardianships for incompetent adults and minor children</li>
        </ul>
      </li>
      <li>Special Proceedings - For example,
        <ul>
          <li>Adoptions</li>
          <li>Motor vehicle liens</li>
          <li>Removal of ward’s personalty from the state</li>
          <li>Petition for sale of a ward’s real property</li>
          <li>Legitimation to add father to birth certificate</li>
          <li>Name changes</li>
          <li>Incompetency cases</li>
          <li>Foreclosure hearings</li>
        </ul>
      </li>
      <li>Registrations - For example,
        <ul>
          <li>Bondsman licenses</li>
          <li>City government and agency documents</li>
          <li>Notice of escheat property</li>
          <li>Oaths of office</li>
          <li>Resumption of former name</li>
        </ul>
      </li>
      <li>Miscellaneous - For example,
        <ul>
          <li>Lis pendens (i.e., notice of suit)</li>
          <li>Real estate license revocation</li>
          <li>NC State Bar Orders of Censure</li>
          <li>Suspension of Disbarment</li>
          <li>State Bar Rule B.123</li>
          <li>IRS tax liens</li>
          <li>North Carolina State tax liens</li>
          <li>Claim of lien</li>
          <li>Other lien types</li>	
        </ul>
      </li>
    </ul>
    <p>Not available in this system are:</p>
      <ul>
        <li>Cases from any jurisdiction other than North Carolina District and Superior Court</li>
        <li>Criminal and infraction cases (other than civil judgments pertaining to these cases)</li>
      </ul>
      <p>This system explicitly does not provide access to non-public information including</p>
      <ul>
        <li>Cases sealed by a judicial order</li>
        <li>Involuntary Commitments</li>
        <li>Personal Identifying Information (PII)</li>
      </ul>
      <h2>Go-Live Dates of Non-Criminal Case Management Features by County</h2>
        <table>
          <thead>
            <tr><th>County</th><th>Judgments and Civil Actions</th><th>All Case Types</th><th>Full
                Judgment Abstracts</th><tr>
          </thead>
          <tbody>
            <tr><td>Alamance</td><td>2/22/1988</td><td>9/20/1997</td><td>3/29/2004</td></tr>
            <tr><td>Alexander</td><td>10/30/1989</td><td>11/1/1997</td><td>8/23/2004</td></tr>
            <tr><td>Alleghany</td><td>11/30/1988</td><td>9/6/1997</td><td>8/9/2004</td></tr>
            <tr><td>Anson</td><td>11/13/1989</td><td>8/30/1997</td><td>1/31/2005</td></tr>
            <tr><td>Ashe</td><td>11/28/1988</td><td>9/6/1997</td><td>7/26/2004</td></tr>
            <tr><td>Avery</td><td>10/24/1988</td><td>8/2/1997</td><td>8/23/2004</td></tr>
            <tr><td>Beaufort</td><td>10/3/1988</td><td>10/5/1996</td><td>8/1/2005</td></tr>
            <tr><td>Bertie</td><td>6/5/1989</td><td>11/9/1996</td><td>6/27/2005</td></tr>
            <tr><td>Bladen</td><td>5/8/1989</td><td>3/29/1997</td><td>11/1/2004</td></tr>
            <tr><td>Brunswick</td><td>3/27/1989</td><td>3/22/1997</td><td>3/8/2004</td></tr>
            <tr><td>Buncombe</td><td>4/11/1988</td><td>7/26/1997</td><td>10/18/2004</td></tr>
            <tr><td>Burke</td><td>10/1/1988</td><td>4/12/1997</td><td>10/4/2004</td></tr>
            <tr><td>Cabarrus</td><td>2/13/1989</td><td>8/23/1997</td><td>2/14/2005</td></tr>
            <tr><td>Caldwell</td><td>11/28/1988</td><td>4/12/1997</td><td>8/23/2004</td></tr>
            <tr><td>Camden</td><td>11/27/1989</td><td>10/12/1996</td><td>2/28/2005</td></tr>
            <tr><td>Carteret</td><td>10/17/1988</td><td>3/29/1997</td><td>10/3/2005</td></tr>
            <tr><td>Caswell</td><td>3/20/1989</td><td>4/12/1997</td><td>5/24/2004</td></tr>
            <tr><td>Catawba</td><td>3/7/1988</td><td>4/26/1997</td><td>4/25/2005</td></tr>
            <tr><td>Chatham</td><td>4/10/1989</td><td>9/20/1997</td><td>6/21/2004</td></tr>
            <tr><td>Cherokee</td><td>5/1/1989</td><td>6/28/1997</td><td>10/25/2004</td></tr>
            <tr><td>Chowan</td><td>11/6/1989</td><td>10/12/1996</td><td>3/14/2005</td></tr>
            <tr><td>Clay</td><td>5/15/1989</td><td>6/21/1997</td><td>10/25/2004</td></tr>
            <tr><td>Cleveland</td><td>2/29/1988</td><td>6/7/1997</td><td>4/11/2005</td></tr>
            <tr><td>Columbus</td><td>5/15/1989</td><td>3/15/1997</td><td>3/8/2004</td></tr>
            <tr><td>Craven</td><td>10/10/1988</td><td>5/10/1997</td><td>10/3/2005</td></tr>
            <tr><td>Cumberland</td><td>3/14/1988</td><td>10/19/1996</td><td>11/15/2004</td></tr>
            <tr><td>Currituck</td><td>11/27/1989</td><td>10/12/1996</td><td>2/28/2005</td></tr>
            <tr><td>Dare</td><td>10/31/1988</td><td>10/19/1996</td><td>8/1/2005</td></tr>
            <tr><td>Davidson</td><td>5/16/1988</td><td>10/4/1997</td><td>4/25/2005</td></tr>
            <tr><td>Davie</td><td>10/23/1989</td><td>10/4/1997</td><td>4/11/2005</td></tr>
            <tr><td>Duplin</td><td>4/17/1989</td><td>3/15/1997</td><td>11/1/2004</td></tr>
            <tr><td>Durham</td><td>1/11/1988</td><td>9/28/1996</td><td>5/17/2004</td></tr>
            <tr><td>Edgecombe</td><td>5/31/1988</td><td>8/24/1996</td><td>6/13/2005</td></tr>
            <tr><td>Forsyth</td><td>4/4/1988</td><td>11/15/1997</td><td>1/24/2005</td></tr>
            <tr><td>Franklin</td><td>6/5/1989</td><td>4/19/1997</td><td>6/21/2004</td></tr>
            <tr><td>Gaston</td><td>5/23/1988</td><td>10/26/1996</td><td>1/31/2005</td></tr>
            <tr><td>Gates</td><td>11/13/1989</td><td>11/9/1996</td><td>2/28/2005</td></tr>
            <tr><td>Graham</td><td>5/15/1989</td><td>6/21/1997</td><td>10/25/2004</td></tr>
            <tr><td>Granville</td><td>6/12/1989</td><td>12/7/1996</td><td>3/29/2004</td></tr>
            <tr><td>Greene</td><td>10/9/1989</td><td>9/28/1996</td><td>6/27/2005</td></tr>
            <tr><td>Guilford</td><td>8/22/1988</td><td>6/14/1997</td><td>12/13/2004</td></tr>
            <tr><td>Halifax</td><td>11/14/1988</td><td>10/19/1996</td><td>6/27/2005</td></tr>
            <tr><td>Harnett</td><td>4/17/1989</td><td>9/14/1996</td><td>5/17/2004</td></tr>
            <tr><td>Haywood</td><td>10/10/1988</td><td>6/21/1997</td><td>9/20/2004</td></tr>
            <tr><td>Henderson</td><td>10/3/1988</td><td>7/19/1997</td><td>5/16/2005</td></tr>
            <tr><td>Hertford</td><td>6/19/1989</td><td>11/9/1996</td><td>3/14/2005</td></tr>
            <tr><td>Hoke</td><td>10/16/1989</td><td>5/17/1997</td><td>11/1/2004</td></tr>
            <tr><td>Hyde</td><td>10/2/1989</td><td>10/12/1996</td><td>7/18/2005</td></tr>
            <tr><td>Iredell</td><td>7/11/1988</td><td>8/30/1997</td><td>4/11/2005</td></tr>
            <tr><td>Jackson</td><td>5/30/1989</td><td>6/28/1997</td><td>10/18/2004</td></tr>
            <tr><td>Johnston</td><td>4/24/1989</td><td>8/31/1996</td><td>2/16/2004</td></tr>
            <tr><td>Jones</td><td>10/16/1989</td><td>3/8/1997</td><td>8/22/2005</td></tr>
            <tr><td>Lee</td><td>4/10/1989</td><td>8/17/1996</td><td>5/24/2004</td></tr>
            <tr><td>Lenoir</td><td>10/24/1988</td><td>9/28/1996</td><td>8/29/2005</td></tr>
            <tr><td>Lincoln</td><td>12/5/1988</td><td>11/8/1997</td><td>2/14/2005</td></tr>
            <tr><td>Macon</td><td>5/22/1989</td><td>6/28/1997</td><td>10/18/2004</td></tr>
            <tr><td>Madison</td><td>11/2/1988</td><td>7/12/1997</td><td>9/20/2004</td></tr>
            <tr><td>Martin</td><td>6/5/1989</td><td>10/26/1996</td><td>6/27/2005</td></tr>
            <tr><td>McDowell</td><td>11/7/1988</td><td>7/12/1997</td><td>10/4/2004</td></tr>
            <tr><td>Mecklenburg</td><td>4/25/1988</td><td>10/25/1997</td><td>5/3/2004</td></tr>
            <tr><td>Mitchell</td><td>10/31/1988</td><td>8/2/1997</td><td>9/20/2004</td></tr>
            <tr><td>Montgomery</td><td>4/10/1989</td><td>12/6/1997</td><td>10/17/2005</td></tr>
            <tr><td>Moore</td><td>3/13/1989</td><td>5/17/1997</td><td>6/21/2004</td></tr>
            <tr><td>Nash</td><td>6/20/1988</td><td>6/21/1996</td><td>1/24/2004</td></tr>
            <tr><td>NewHanover</td><td>4/18/1988</td><td>2/15/1997</td><td>3/1/2004</td></tr>
            <tr><td>Northampton</td><td>6/12/1989</td><td>11/16/1996</td><td>3/14/2005</td></tr>
            <tr><td>Onslow</td><td>8/15/1988</td><td>2/22/1997</td><td>9/19/2005</td></tr>
            <tr><td>Orange</td><td>5/22/1989</td><td>5/17/1997</td><td>4/19/2004</td></tr>
            <tr><td>Pamlico</td><td>9/18/1989</td><td>3/1/1997</td><td>8/22/2005</td></tr>
            <tr><td>Pasquotank</td><td>3/6/1989</td><td>10/26/1996</td><td>1/24/2004</td></tr>
            <tr><td>Pender</td><td>9/18/1989</td><td>9/28/1996</td><td>3/8/2004</td></tr>
            <tr><td>Perquimans</td><td>10/23/1989</td><td>11/16/1996</td><td>2/28/2005</td></tr>
            <tr><td>Person</td><td>4/17/1989</td><td>4/26/1997</td><td>5/24/2004</td></tr>
            <tr><td>Pitt</td><td>7/11/1988</td><td>11/2/1996</td><td>6/13/2005</td></tr>
            <tr><td>Polk</td><td>5/30/1989</td><td>8/2/1997</td><td>5/16/2005</td></tr>
            <tr><td>Randolph</td><td>2/6/1989</td><td>5/24/1997</td><td>4/25/2005</td></tr>
            <tr><td>Richmond</td><td>4/24/1989</td><td>5/3/1997</td><td>10/3/2005</td></tr>
            <tr><td>Robeson</td><td>6/27/1988</td><td>3/8/1997</td><td>9/26/2005</td></tr>
            <tr><td>Rockingham</td><td>2/13/1989</td><td>9/27/1997</td><td>3/29/2004</td></tr>
            <tr><td>Rowan</td><td>2/6/1989</td><td>9/6/1997</td><td>4/25/2005</td></tr>
            <tr><td>Rutherford</td><td>10/17/1988</td><td>7/12/1997</td><td>5/16/2005</td></tr>
            <tr><td>Sampson</td><td>4/24/1989</td><td>3/22/1997</td><td>11/15/2004</td></tr>
            <tr><td>Scotland</td><td>3/20/1989</td><td>5/3/1997</td><td>9/26/2005</td></tr>
            <tr><td>Stanly</td><td>10/16/1989</td><td>11/15/1997</td><td>2/14/2005</td></tr>
            <tr><td>Stokes</td><td>9/19/1988</td><td>9/6/1997</td><td>7/26/2004</td></tr>
            <tr><td>Surry</td><td>10/31/1988</td><td>12/6/1997</td><td>2/16/2004</td></tr>
            <tr><td>Swain</td><td>5/8/1989</td><td>6/28/1997</td><td>5/2/2005</td></tr>
            <tr><td>Transylvania</td><td>5/22/1989</td><td>7/19/1997</td><td>5/16/2005</td></tr>
            <tr><td>Tyrrell</td><td>10/30/1989</td><td>10/5/1996</td><td>7/18/2005</td></tr>
            <tr><td>Union</td><td>3/13/1989</td><td>12/6/1997</td><td>1/31/2005</td></tr>
            <tr><td>Vance</td><td>3/27/1989</td><td>1/25/1997</td><td>5/17/2004</td></tr>
            <tr><td>Wake</td><td>2/1/1988</td><td>10/5/1996</td><td>10/11/2004</td></tr>
            <tr><td>Warren</td><td>3/20/1989</td><td>1/25/1997</td><td>4/19/2004</td></tr>
            <tr><td>Washington</td><td>12/4/1989</td><td>10/12/1996</td><td>8/1/2005</td></tr>
            <tr><td>Watauga</td><td>12/5/1988</td><td>10/4/1997</td><td>7/26/2004</td></tr>
            <tr><td>Wayne</td><td>7/18/1988</td><td>9/21/1996</td><td>11/15/2004</td></tr>
            <tr><td>Wilkes</td><td>12/5/1988</td><td>6/7/1997</td><td>8/9/2004</td></tr>
            <tr><td>Wilson</td><td>8/29/1988</td><td>8/24/1996</td><td>6/13/2005</td></tr>
            <tr><td>Yadkin</td><td>11/13/1989</td><td>12/6/1997</td><td>8/9/2004</td></tr>
            <tr><td>Yancey</td><td>10/26/1988</td><td>7/19/1997</td><td>9/20/2004</td></tr>
          </tbody>
        </table>
        <button class="btn btn-primary pull-right" (click)="closeTellMeMore()">Close</button>
      </div>
  </ng-template>
  <ng-template #juvenileTellMeMore>
    <div class="modal-header">
        <h1 class="logo float-left">
            North Carolina Judicial Branch
        </h1>
        <button class="btn btn-primary btn-ciprs pull-right" (click)="closeTellMeMore()">Close</button>
    </div>
    <div class="modal-body container-fluid">
      <h1>What Juvenile Court Records Can I Find Here?</h1>
      <p>This system provides users who meet the legal requirements access to the electronically available juvenile delinquency case records in the juvenile courts of the North Carolina Judicial Branch. This system does not maintain case information for federal cases or North Carolina Appellate or Supreme Court cases.</p>
      <p>The delinquency records are produced from the clerk’s juvenile index and case management system. The system was implemented across North Carolina between the years 2004 and 2007. Cases that originated prior to each county’s implementation are entered only if a new petition is filed.  If there is information missing, please access the juvenile file in the office of the clerk of superior court in the county where the petition was filed.</p>
      <p>A search in the system can be conducted by entering the name, NC-JOIN number (a unique identifier assigned to each juvenile by the NC Department of Public Safety, Division of Adult Correction and Juvenile Justice), or case number. All searches will utilize the NC-JOIN number to identify if the juvenile has other delinquency cases in the State.</p>
      <p>The following case information may be found in this system:</p>
      <ul>
        <li>Juvenile name, known aliases, minimal identifying information, and attorney assignment</li>
        <li>Current and previous allegations</li>
        <li>Allegation service and order information</li>
        <li>Current and previous court events</li>
        <li>Case File Details and file status</li>
        <li>Case party Information and party roles (e.g. parent/legal guardian, petitioner, victim, DSS social worker.)</li>
      </ul>
      <p>Information not available in this system are:</p>
      <ul>
        <li>Case co-respondents</li>
        <li>Non-delinquency juvenile case information (e.g. abuse, neglect, dependency matters)</li>
        <li>Juvenile Delinquency cases which have been appealed</li>
      </ul>
      <p>The <u>Rules of Recordkeeping Procedures for the North Carolina Offices of the Clerk of Superior Court</u> direct that each county shall maintain one delinquency case record for each juvenile who enters the juvenile court jurisdiction. Each case may have information on multiple petitions spanning many years, depending on the juvenile.</p>
      <button class="btn btn-primary pull-right" (click)="closeTellMeMore()">Close</button>
  </div>
</ng-template>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/landing/landing.component.html